<template>
    <div>
        <el-card shadow="hover">
            <el-form inline :model="query" size="small">
                <div @keydown.enter="doQuery()">
                    <div style="float: left;">
                        <el-form-item>
                            <el-select v-model="query.pid" placeholder="请选择招聘计划" style="width:250px;" @change="doQuery">
                                <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" icon="el-icon-upload2" @click="doUpload">上传成绩</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" icon="el-icon-upload2" @click="doUploadMianshi">上传面试信息</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" icon="el-icon-s-promotion" @click="doWxmnNotify">发送小程序通知</el-button>
                        </el-form-item>
                    </div>
                    <div style="float: right;">
                        <el-form-item>
                            <el-input v-model="query.name" clearable placeholder="考生姓名" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.idno" clearable placeholder="身份证号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-input v-model="query.zkzno" clearable placeholder="准考证号" style="width:180px;"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="查询" placement="top">
                                <el-button type="warning" size="small" icon="el-icon-search" circle @click="doQuery"></el-button>
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item>
                            <el-tooltip effect="dark" content="清空查询条件" placement="top">
                                <el-button size="small" icon="el-icon-refresh" circle @click="doReset"></el-button>
                            </el-tooltip>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
        </el-card>
        <!--Table-->
        <el-card shadow="hover" style="margin-top: 10px;">
            <el-table ref="table" v-loading="tableLoading" :data="datas" highlight-current-row :border="true" stripe tooltip-effect="dark" style="width: 100%">
                <el-table-column show-overflow-tooltip label="考生信息" width="500">
                    <template slot-scope="scope">
                        <p>{{ scope.row.zkzno }} / {{ scope.row.name }} [{{ scope.row.idno }}] / {{ scope.row.sno }}</p>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="成绩信息">
                    <template slot-scope="scope">
                        <span v-for="item in scope.row.info" :key="item.item" style="margin-right: 20px;">[{{ item.item }} : {{ item.rst }}]</span>
                    </template>
                </el-table-column>
            </el-table>
        </el-card>
        <el-card shadow="hover" v-show="this.data.pages > 1" style="margin-top: 10px;">
            <el-pagination
                background
                @current-change="doChangePage"
                @size-change="doChangeSize"
                :current-page="this.data.page"
                :page-sizes="[10, 30, 50, 100]"
                :page-size="this.query.size"
                layout="-> ,total,  prev, pager, next, jumper, sizes"
                :total="this.data.rows"
            />
        </el-card>
        <!--Form-->
        <el-dialog title="上传成绩" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialog" width="500px">
            <el-form ref="form" :model="field" :rules="rules" label-width="100px">
                <el-form-item label="招聘计划" prop="pid">
                    <el-select v-model="field.pid" placeholder="请选择招聘计划" style="width: 100%;">
                        <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="数据起始行" prop="start">
                    <el-input v-model="field.start" type="number" placeholder="请填写数据起始行，行数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="考生姓名列" prop="name">
                    <el-input v-model="field.name" type="number" placeholder="请填写姓名所属列，列数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="身份证号列" prop="idno">
                    <el-input v-model="field.idno" type="number" placeholder="请填写身份证号所属列，列数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="准考证号列" prop="zkzno">
                    <el-input v-model="field.zkzno" type="number" placeholder="请填写准考证号所属列，列数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="成绩信息列" prop="info">
                    <el-input v-model="field.info" placeholder="请填写成绩信息列，多个以`,`区分"></el-input>
                </el-form-item>
                <el-form-item label="数据文件" prop="file">
                    <el-upload action="action" :auto-upload="false" :file-list="fileList" :on-change="onFileChange">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmit">
                    上传
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialog = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
        <!-- 上传面试信息 -->
        <el-dialog title="上传面试成绩" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="formDialogMianshi" width="500px">
            <el-form ref="form" :model="field" :rules="rules" label-width="100px">
                <el-form-item label="招聘计划" prop="pid">
                    <el-select v-model="field.pid" placeholder="请选择招聘计划" style="width: 100%;">
                        <el-option v-for="plan in plans" :key="plan.id" :label="plan.name" :value="plan.id"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item label="数据起始行" prop="start">
                    <el-input v-model="field.start" type="number" placeholder="请填写数据起始行，行数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="考生姓名列" prop="name">
                    <el-input v-model="field.name" type="number" placeholder="请填写姓名所属列，列数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="身份证号列" prop="idno">
                    <el-input v-model="field.idno" type="number" placeholder="请填写身份证号所属列，列数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="报名序号列" prop="zkzno">
                    <el-input v-model="field.zkzno" type="number" placeholder="请填写准考证号所属列，列数从1开始"></el-input>
                </el-form-item>
                <el-form-item label="成绩信息列" prop="info">
                    <el-input v-model="field.info" placeholder="请填写成绩信息列，多个以`,`区分"></el-input>
                </el-form-item> -->
                <el-form-item label="数据文件" prop="file">
                    <el-upload action="action" :auto-upload="false" :file-list="fileList" :on-change="onFileChange">
                        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                    </el-upload>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" :loading="submitLoading" size="medium" icon="el-icon-circle-check" @click="doSubmitMianshi">
                    上传
                </el-button>
                <el-button type="info" plain size="medium" icon="el-icon-switch-button" @click="formDialogMianshi = false">
                    关闭
                </el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const defaultQuery = {
    page: 1,
    size: 10,
    time: 0,
    pid: '',
    idno: '',
    name: '',
    zkzno: ''
}

const defaultField = {
    pid: '',
    start: 1,
    idno: 1,
    zkzno: 1,
    name: 1,
    info: '',
    file: undefined
}

export default {
    name: 'Ers',
    data() {
        return {
            query: {
                ...defaultQuery
            },
            data: {
                rows: 0,
                pages: 0,
                page: 1,
                time: 0
            },
            tableLoading: false,
            datas: [],
            plans: [],
            fileList: [],
            field: {
                ...defaultField
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: '请填写考生姓名列',
                        trigger: 'blur'
                    }
                ],
                pid: [
                    {
                        required: true,
                        message: '请选择招聘计划',
                        trigger: 'blur'
                    }
                ],
                start: [
                    {
                        required: true,
                        message: '请填写数据起始行',
                        trigger: 'blur'
                    }
                ],
                idno: [
                    {
                        required: true,
                        message: '请填写身份证号列',
                        trigger: 'blur'
                    }
                ],
                info: [
                    {
                        required: true,
                        message: '请填写成绩信息列',
                        trigger: 'blur'
                    }
                ],
                zkzno: [
                    {
                        required: true,
                        message: '请填写准考证号列',
                        trigger: 'blur'
                    }
                ]
            },
            formDialog: false,
            formDialogMianshi: false,
            submitLoading: false
        }
    },
    mounted() {
        this.$store.commit('setBreadcrumb', ['招聘管理', '成绩信息'])
        this.init()
    },
    computed: {
        platUser() {
            return this.$has('PlatAdmin') || this.$has('PlatAudit')
        }
    },
    methods: {
        init() {
            this.doLoadPlan()
        },
        doLoadPlan() {
            this.$http
                .get('/comm/data/plan/query', {
                    params: {
                        _: new Date().getTime()
                    }
                })
                .then(result => {
                    this.plans = result.datas
                    if (this.plans && this.plans.length > 0) {
                        this.query.pid = this.plans[0].id
                        this.doLoad()
                    }
                })
        },
        doLoad() {
            if (!this.query.pid) {
                this.$message.error('请选择招聘计划')
                return
            }
            this.tableLoading = true
            this.$http
                .get('/ops/recruit/results/list', {
                    params: this.query
                })
                .then(result => {
                    this.tableLoading = false
                    if (result.data.page === 1) {
                        this.query.time = result.data.time
                    }
                    this.data = result.data
                    this.datas = result.datas
                })
        },
        doQuery() {
            this.query.page = 1
            this.doLoad()
        },
        doReset() {
            this.query = {
                ...defaultQuery
            }
            if (this.plans.length > 0) {
                this.query.pid = this.plans[0].id
            }

            this.doQuery()
        },
        doChangePage(num) {
            this.query.page = num
            this.doLoad()
        },
        doChangeSize(num) {
            this.query.page = 1
            this.query.size = num
            this.doLoad()
        },
        clearFields() {
            this.field = {
                ...defaultField
            }
            if (this.$refs['form']) {
                this.$refs['form'].resetFields()
                this.$refs['form'].clearValidate()
            }
            this.fileList = []
        },
        doUpload() {
            this.clearFields()
            if (!this.query.pid) {
                this.$message.error('请选择招聘计划')
                return
            }
            this.field.pid = this.query.pid
            this.formDialog = true
        },
        doUploadMianshi() {
            this.clearFields()
            if (!this.query.pid) {
                this.$message.error('请选择招聘计划')
                return
            }
            this.field.pid = this.query.pid
            this.formDialogMianshi = true
        },
        onFileChange(file) {
            this.field.file = file.raw
        },
        doSubmit() {
            if (this.field.file === undefined) {
                this.$message.error('请选择数据文件')
                return
            }
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/results/upload', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialog = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doSubmitMianshi() {
            if (this.field.file === undefined) {
                this.$message.error('请选择数据文件')
                return
            }
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    this.$http.post('/ops/recruit/reg/aiv/upload', this.field).then(result => {
                        this.submitLoading = false
                        if (result.code === 0) {
                            this.doLoad()
                            this.formDialogMianshi = false
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                }
            })
        },
        doWxmnNotify() {
            if (!this.query.pid) {
                this.$message.error('请选择招聘计划')
                return
            }
            this.submitLoading = true
            this.$http.post('/ops/recruit/results/wxmn/notify', { pid: this.query.pid }).then(result => {
                this.submitLoading = false
                if (result.code === 0) {
                    this.$message.success('提交发送通知成功')
                }
            })
        }
    }
}
</script>
